import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Lista from './laudoImportacaoLista';
import Form from './laudoImportacaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, excluirGeral, getListaResumido } from './laudoImportacaoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LaudoImportacaoProcesso from './laudoImportacaoProcesso';

class LaudoImportacao extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getListaResumido();
    }

    render() {
		
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'importacao' ? (
						<LaudoImportacaoProcesso />
					) : null}
					{this.props.modoTela == 'listaImportada' ? (
						<Lista />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		let lista = (this.props.lista).filter(item => {
			if (this.state.pesquisar
				&& !(`${item.competencia} ${FormatUtils.formatarCompetenciaTela(item.competencia)} ${item.nome_hospital}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			return true;
		});

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Importar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('importacao', {});
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>

					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value, paginacaoIndice: 0 });
						}} />

					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter width={50}>Competência</Th>
								<Th alignCenter>Hospital</Th>
								<Th alignCenter>Itens</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{FormatUtils.formatarCompetenciaTela(item.competencia)}</Td>
									<Td alignCenter>{item.nome_hospital}</Td>
									<Td alignCenter>{item.itens || 0 }</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											type={'success'}
											icon={'fas fa-eye'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('listaImportada', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
											
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												if (window.confirm('Deseja realmente excluir toda a importação?')) {
													this.props.excluirGeral({
														...item
													});
												}
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.laudoImportacao.modoTela,
	aguardando: state.laudoImportacao.aguardando,
	lista: state.laudoImportacao.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, excluirGeral, getListaResumido
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacao);